export default __webpack_public_path__ + "static/media/driver.23134d5b.svg";